import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { MissingPasswordClient } from "./missing-password.client";
import { MissingPasswordModel } from "./missing-password.model";

/**
 * @deprecated - [fabric-deprecated] - Use MissingPasswordService from app-account mfe instead
 */
@Injectable({
	providedIn: "root",
})
export class MissingPasswordService {
	constructor(private client: MissingPasswordClient) {}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.SetMissingPassword) instead
	 */
	set(model: MissingPasswordModel): Observable<object> {
		return this.client.set(model);
	}
}
